// extracted by mini-css-extract-plugin
module.exports = {"root":"BlocksEditor_root__6Vtph","addButton":"BlocksEditor_addButton__g5PBZ"};